import { render, staticRenderFns } from "./mstrbudgetfrm.vue?vue&type=template&id=5605b5a2"
import script from "./mstrbudgetfrm.vue?vue&type=script&lang=js"
export * from "./mstrbudgetfrm.vue?vue&type=script&lang=js"
import style0 from "./mstrbudgetfrm.vue?vue&type=style&index=0&id=5605b5a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports